<template>
    <div class="carousel--card" @click="onClick">
        <div :class="{'carousel-item-container': true, 'active': activePlaybackId === item.id}">
            <img v-if="canShowOriginalThumbnail"
                 :src="item.attributes.urls.thumbnail"
                 @error="onThumbnailError"
                 alt="placeholder"
            >
            <img v-else src="../../../../assets/img/thumbnail.jpg" alt="placeholder">
            <slot />
        </div>
    </div>
</template>

<script>

export default {
    name: 'CarouselItem',
    props: {
        item: { type: Object },
        activePlaybackId: { type: String }
    },
    data() {
        return {
            thumbnailError: false
        }
    },
    methods: {
        onThumbnailError() {
            this.thumbnailError = true
        },
        onClick() {
            this.$emit('click', this.item.id)
        }
    },
    computed: {
        canShowOriginalThumbnail() {
            return this.item.attributes.urls.thumbnail && !this.thumbnailError
        }
    }
}
</script>
